import React from "react";
import { SiteHeader } from "../components/SiteHeader";
import { Hero } from "../components/Hero";
import { ConnectionSection } from "../components/ConnectionSection";
import { SolutionSection } from "../components/SolutionSection";
import { ContentsSection } from "../components/ContentsSection";
import { ActivityBookSection } from "../components/ActivityBookSection";
import { EmotionalSection } from "../components/EmotionalSection";
import { BonusSection } from "../components/BonusSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { PersonaSection } from "../components/PersonaSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { OfferSection } from "../components/OfferSection";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  return <div className="min-h-screen w-full bg-ivory font-sans text-cocoa" data-id="element-273" data-mp="2bbpcb0o220h">
      <SiteHeader data-id="element-274" data-mp="3tfa2zeh5g07d" />
      <main data-id="element-275" data-mp="3tes1a2bpwts2">
        <Hero data-id="element-276" data-mp="3tifuf0d93e69" />
        <ConnectionSection data-id="element-277" data-mp="3tio4kkhzo5dr" />
        <SolutionSection data-id="element-278" data-mp="3pe85p36sly81" />
        <ContentsSection data-id="element-279" data-mp="3pfj6qv8usrvg" />
        <ActivityBookSection data-id="element-280" data-mp="3pguaww67o1n3" />
        <EmotionalSection data-id="element-281" data-mp="3kfwtilt0zbmn" />
        <BonusSection data-id="element-282" data-mp="3kgoobuest5bv" />
        <HowItWorksSection data-id="element-283" data-mp="3khhnoabfgsjz" />
        <PersonaSection data-id="element-284" data-mp="l0ibk80o5br1" />
        <TestimonialsSection data-id="element-285" data-mp="l11h0p94u7o6" />
        <OfferSection data-id="element-286" data-mp="kz8d3hpwm1jv" />
        <GuaranteeSection data-id="element-287" data-mp="l2mbkevg5qm1" />
        <FaqSection data-id="element-288" data-mp="gz6ittmi0aem" />
        <ClosingSection data-id="element-289" data-mp="gyoe08lrsnv3" />
      </main>
      <SiteFooter data-id="element-290" data-mp="gzpzl70ewsr2" />
    </div>;
}